import React from 'react';
import classnames from 'classnames';
import { Field, getIn } from 'formik';
import './CheckBox.scss';

class CheckBox extends React.Component {
  render() {
    const {
      name,
      value,
      form,
      childTop,
      error,
      checked,
      ...props
    } = this.props;
    const wrapperClass = classnames({
      'form-check': true
    });

    const labelClass = classnames({
      'form-check-label': true
    });

    const checkboxClass = classnames({
      'form-check-input': true
    });

    return (
      <Field name={name}>
        {({ field, form: { touched, errors } }) => (
          <div
            className={`${wrapperClass} ${
              getIn(touched, name) && getIn(errors, name) ? 'has-error' : ''
            }`}
          >
            <label className={labelClass}>
              <input
                {...field}
                {...props}
                value={value}
                type="checkbox"
                className={checkboxClass}
                checked={
                  checked ||
                  (field.value &&
                    Array.isArray(field.value) &&
                    field.value.includes(value))
                }
              />
              <span>
                <i className="far fa-square"></i> {this.props.text}
              </span>
            </label>
          </div>
        )}
      </Field>
    );
  }
}

export default CheckBox;
